import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Fetches recommended LinkedIn posting times from the API.
 * Used by all content generators that show "Post on LinkedIn" and posting time hint.
 */
export function usePostingTime() {
  const [postingTimeSummary, setPostingTimeSummary] = useState('');

  useEffect(() => {
    const fetchPostingTime = async () => {
      try {
        const response = await axios.get('/api/posting-time/suggest');
        if (response.data.success && response.data.output) {
          const data = JSON.parse(response.data.output);
          const days = (data.bestDays || []).join(', ');
          const times = (data.bestTimes || [])
            .map((t) => t.time)
            .join(' | ');
          if (days && times) {
            setPostingTimeSummary(`${days} — ${times}`);
          }
        }
      } catch (e) {
        // Fail silently; generators still work without posting time info
      }
    };

    fetchPostingTime();
  }, []);

  return postingTimeSummary;
}
